import axios from "axios";
import grupos from "./grupos";
export default {
    namespaced: true,
    state: {
        dialog: false,
        usuario: {},
        usuarios: [],
        gruposUsuario: [],
        color: '',
        editandoUsuario: '',
        loadingUsuarios: false,
    },
    mutations: {
        SET_DIALOG(state, mostrar) {
            state.dialog = mostrar
        },
        SET_USUARIOS(state, respuesta) {
            state.usuarios = [];
            let usuarios = [];
            respuesta.data.forEach(usuario => {
                let estado = usuario.habilitado ? 'Habilitado' : 'Deshabilitado';
                // usuario.grupos.forEach(grupo => grupo.id)
                usuarios.push({
                    id: usuario.id,
                    nombre: usuario.name,
                    apellidos: usuario.apellidos,
                    email: usuario.email,
                    fechaCreacion: usuario.created_at,
                    habilitado: usuario.habilitado,
                    telefono: usuario.telefono,
                    observaciones: usuario.observaciones,
                    estado: estado,
                    avatar: usuario.avatar,
                    color: usuario.color,
                    grupos: usuario.grupos.map(g => g.id),
                    equipos: usuario.equipos,
                    nombreCompleto: usuario.name + ' ' + usuario.apellidos
                });
            });
            state.usuarios = usuarios;
        },
        SET_USUARIO(state, usuario) {
            state.usuario = usuario;
            // state.usuario.name = usuario.name;
            // state.usuario.apellidos = usuario.apellidos;
            // state.usuario.avatar = usuario.avatar;
            // state.usuario.color = usuario.color;
            // state.usuario.telefono = usuario.telefono;
            // state.usuario.habilitado = usuario.habilitado;
            // state.usuario.observaciones = usuario.observaciones;
            // state.usuario.idTipoUsuario = usuario.idTipoUsuario;
            state.usuario.gruposAsignados = []; // Vacío el array cada vez que entro para evitar que se dupliquen valores al volver a entrar por el push
            // Recorro el listado de grupos obtenidos por la API para quedarme únicamente con el id
            usuario.grupos.forEach(element =>
                state.usuario.gruposAsignados.push(element.id)
            );
            state.editandoUsuario = true;
            // console.log(state.usuario);
            // FIN
        },
        SET_NUEVOUSUARIO(state) {
            state.editandoUsuario = false;
            let colores = ['pink darken-1', 'purple darken-1', 'deep-purple darken-1', 'indigo darken-1', 'blue darken-1', 'light-blue darken-1', 'cyan darken-1', 'green darken-1', 'orange darken-1', 'brown darken-1', 'blue-grey darken-1', 'red darken-1', 'deep-orange darken-1', 'green accent-4', 'lime accent-4', 'cyan accent-3', 'pink darken-4'];
            state.usuario = {
                name: '',
                apellidos: '',
                email: '',
                password: '',
                telefono: '',
                avatar: 'NU',
                color: colores[Math.floor(Math.random() * colores.length)],
                habilitado: 1,
                observaciones: '',
                idTipoUsuario: '',
                gruposAsignados: [],
                habilitado: 1,
                ipsConfianza: '*'
            }
        },
        // SET_NOMBRE(state, nombreNuevo){
        //     state.usuario.nombre = nombreNuevo
        // },
        // SET_APELLIDOS(state, apellidosNuevo){
        //     state.usuario.apellidos = apellidosNuevo
        // },
        // SET_TELEFONO(state, telefonoNuevo){
        //     state.usuario.telefono = telefonoNuevo
        // },
        // SET_HABILITADO(state, habilitado){
        //     state.usuario.habilitado = habilitado
        // },
        // SET_OBSERVACIONES(state, observacionesNuevo){
        //     state.usuario.observaciones = observacionesNuevo
        // },
        SET_GRUPOSUSUARIO(state, grupos) {
            //console.log(grupos);
            state.gruposUsuario = grupos;
        },
        SET_LOADING(state, value) {
            state.loadingUsuarios = value
        }

    },
    getters: {
        usuarios: state => state.usuarios,
        tecnicos: state => state.usuarios.filter(user => user.grupos.includes(2)),
        comerciales: state => state.usuarios.filter(user => user.grupos.includes(3)),
        loadingUsuarios: state => state.loadingUsuarios,
        userById: state => id => {
            return state.usuarios.find(user => user.id === id)
        },
        userNameById: (state, getters) => id => {
            const user = getters.userById(id)
            return user ? user.nombreCompleto : null
        }
    },
    actions: {
        setDialog({
            commit
        }, mostrar) {
            commit('SET_DIALOG', mostrar);
        },
        setUsuario({
            commit
        }, usuario) {
            commit('SET_USUARIO', usuario);
        },
        setUsuarios({
            commit
        }, respuesta) {
            commit('SET_USUARIOS', respuesta);
        },
        setNuevoUsuario({
            commit
        }) {
            commit('SET_NUEVOUSUARIO');
        },
        setGruposUsuario({
            commit
        }, grupos) {
            commit('SET_GRUPOSUSUARIO', grupos);
        },
        getUsuarios({
            commit,
            dispatch,
            state
        }) {
            commit('SET_LOADING', true);
            return axios
                .get(`api/usuarios`)
                .then((res) => {

                    commit('SET_USUARIOS', res)
                    commit('SET_LOADING', false);
                })
                .catch((err) => {
                    commit('SET_LOADING', false);
                    dispatch('setSnackbar', {
                        tipo: "error",
                        mensaje: "Error. No se han podido recuperar los tecnicos",
                    }, {
                        root: true
                    });
                });
        },

    }
}